import '@/styles/index.scss'

import { createApp } from 'vue'
import App from './App.vue'
import store from './store'
import mixins from './mixins'
import VueScrollTo from 'vue-scrollto'

createApp(App).use(store).mixin(mixins).use(VueScrollTo).mount('#app')
